export default [
    {
        path: '/branches',
        name: 'Company / Branches',
        component: () => import('@/views/pages/branches'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: 'create',
                name: 'Create Company / Branch',
                component: () => import('@/views/pages/branches'),
                meta:
                {
                    page: 'create',
                    subPage: 'main',
                },
            },
            {
                path: ':code',
                name: 'View Company / Branch',
                component: () => import('@/views/pages/branches'),
                meta:
                {
                    page: 'view',
                },
                children:
                [
                    {
                        path: 'edit',
                        name: 'Edit Company / Branch',
                        component: () => import('@/views/pages/branches'),
                        meta:
                        {
                            page: 'edit',
                            subPage: 'main',
                        },
                    },
                ],
            },
        ],
    },
];